import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import SendIcon from '@mui/icons-material/Send';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  onClose: () => void;
}

export const FeedbackModal: React.FC<Props> = props => {
  const { onClose } = props;
  const { t } = useTranslationWithPrefix('layouts.topBar.modal.feedback');

  const handleSendFeedback = () => {
    onClose();
    setTimeout(() => {
      window.location.href = `mailto:?subject=${encodeURIComponent(t('email.subject'))}&to=support.knowme@bluesoft.com`;
    }, 100);
  };

  return (
    <Dialog onClose={onClose} open>
      <DialogTitle color={themeColors.black_80}>{t('title')}</DialogTitle>
      <DialogContent sx={{ minHeight: '150px' }}>
        <Stack spacing={2} sx={{ alignItems: 'center', pt: 4 }}>
          <CampaignOutlinedIcon sx={{ fontSize: 64 }} />
          <Typography
            color={themeColors.black_80}
            sx={{
              lineHeight: '30px',
              textAlign: 'justify',
              textJustify: 'inter-word',
              whiteSpace: 'pre-line',
            }}
            variant="f16Regular"
          >
            {t('content')
              .split('{{email}}')
              .map((part, index, arr) =>
                index < arr.length - 1 ? (
                  <React.Fragment key={index}>
                    {part}
                    <u>
                      <i>support.knowme@bluesoft.com</i>
                    </u>
                  </React.Fragment>
                ) : (
                  part
                ),
              )}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t('button.close')}
        </Button>
        <Button endIcon={<SendIcon />} onClick={handleSendFeedback}>
          {t('button.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
